import React from 'react';
import './checkout.scss';
import InviteAndEarn from 'components/web/InviteAndEarn/InviteAndEarn';
import Input from 'components/mweb/Input/Input';
import Button from 'components/common/Button/Button';
import { Link } from 'react-router-dom';
import {
  getOrderConfirmation,
  subscribeNewUser,
  resetOrderConfirmation,
} from 'hb-redux-store/feature/checkout/checkout.action';
import { connect } from 'react-redux';
import orderConfirmationImage from '../../../assets/order-confirmation-paperbag.png';
import OrderDetails from '../account/OrderDetails';
import {
  isValidEmail,
  isObjectEmpty,
} from 'hb-redux-store/util/miscellaneousServices';
import { setAppNotification } from 'hb-redux-store/initial.action';
import {
  PAYMENT_SUCCESSFUL,
  PARTIAL_COD,
  PARTIAL_POD,
  HB_PRIME,
  HB_POINT,
} from 'hb-redux-store/constants/checkout';
import Loader from '../../mweb/Skeletons/Loader/Loader';
import { showConfirmationPageModal } from '../../../hb-redux-store/feature/modal/modal.action';
import Icon from '../../mweb/Icon/Icon';
import SimpleModal from '../../mweb/Modal/SimpleModal';
import earnCoin from 'assets/icons/earncoin.svg';
import delivery from 'assets/icons/Delivery.svg';
import giftIcon from 'assets/icons/gift-oval.svg';
import Messages from 'components/mweb/Messages/Messages';
import MembershipPaymentMessage from 'components/mweb/HalalboxPrime/MembershipPaymentMessage';
import AnalyticsService from 'AnalyticsService';
import { convertArrayToObject } from 'hb-redux-store/util/miscellaneousServices';

const { clevertap } = AnalyticsService;
class OrderConfirmation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      orderDetails: '',
    };
    this.orderNo = props.match.params.orderNo;
    this.state = { email: '', emailErrorMsg: '' };
    // this.orderId = '#20200515-XRTEOP';
    // this.orderConfirmationImage = 'https://ik.imagekit.io/iwcam3r8ka/random/202005/77a37953-c043-434d-b3e3-6b8986cdeb40.jpg';
    //   this.orderConfirmationImage =
    //     '../../../assets/order-confirmation-paperbag.jpg';
    this.oxygenIcon =
      'https://ik.imagekit.io/iwcam3r8ka/prod/emails/202105/be03c0ad-13f3-475b-a9ef-253bf80caaac.png';
    this.kettoIcon =
      'https://ik.imagekit.io/iwcam3r8ka/prod/emails/202105/849092bd-7ff0-43f0-ab01-1afea223ac79.png';
  }
  componentDidMount() {
    this.props.getOrderConfirmation({ orderNo: this.orderNo });
  }

  static getDerivedStateFromProps(prevProps, prevState) {
    const { orderConfirmationDetails, match, launchInfo } = prevProps || {};
    const { adcCode, customerType } = launchInfo || {};
    const { cartItems, priceDetails } =
      orderConfirmationDetails?.orderDetails || {};
    const { orderTotalAmount } = priceDetails || {};
    if (cartItems?.length > 0) {
      const key = 'Purchase';
      const payload = {
        ...convertArrayToObject(cartItems || []),
        cartItemTotalAmount: orderTotalAmount,
        orderID: match.params.orderNo,
        customerType,
        serviceAbleArea: adcCode,
      };

      clevertap.sendCleverTapEvent(key, payload);
    }
    return null;
  }

  componentWillUnmount() {
    this.props.resetOrderConfirmation();
  }

  subscribeToOffers = () => {
    if (!this.state.email.length || !isValidEmail(this.state.email)) {
      this.setState({ emailErrorMsg: 'Please enter valid email Id. ' });
      return;
    }
    const data = {
      accountEmail: this.state.email,
      subscriptionType: 'dealsAndOffers',
    };
    const cb = () =>
      this.props.setAppNotification(
        'Subscribed! You will be receiving latest updates from VXL. Stay tuned!'
      );
    this.props.subscribeNewUser(data, cb);
    this.setState({ emailErrorMsg: '' });
  };

  render() {
    const {
        orderConfirmationDetails,
        loading,
        showDonationModal,
        setDonationModal,
      } = this.props,
      { orderDetails } = this.state;
    let {
      orderType,
      paymentLink,
      paid,
      orderPayableAmount,
      ccalogin,
      baseUrl,
      deliveryDetails,
      hbPoints,
      banners = [],
      amountSavedMessage = '',
      membershipDetails = {},
    } = orderConfirmationDetails || {};
    console.log('Is CCA: ', ccalogin, baseUrl);
    if (ccalogin && baseUrl) {
      window.location.href = `${baseUrl}/order/edit/${this.orderNo}`;
    }
    const showMembershipDetails = isObjectEmpty(membershipDetails);
    const getPaymentText = (orderNo, orderConfirmationDetails) => {
      if (!orderConfirmationDetails)
        return { primaryTextDiv: false, secondaryTextDiv: false };
      const {
        orderType,
        orderPayableAmount,
        isPartialPayment,
        paid,
        diffPartialPaymentAmount,
        paymentLink,
        orderDetails,
      } = orderConfirmationDetails;
      const successClass = 'icon-common-green-tick',
        pendingClass = 'icon-common-red-exclamation';
      let primaryText,
        primaryIconClass = successClass,
        secondaryText,
        secondaryIconClass = pendingClass;
      const onlyMembershipBuy = !!orderNo && orderNo.startsWith('HM');
      const partialPaidAmount =
        isPartialPayment && !!orderPayableAmount && !!diffPartialPaymentAmount
          ? orderPayableAmount - diffPartialPaymentAmount
          : 0;

      if (!!onlyMembershipBuy && showMembershipDetails) {
        primaryText = HB_PRIME;
      } else if (orderType === 'POL' || orderType === 'HBW') {
        primaryText = PAYMENT_SUCCESSFUL(orderPayableAmount);
      } else if (isPartialPayment) {
        if (orderType === 'COD') {
          primaryText = PAYMENT_SUCCESSFUL(partialPaidAmount);
          secondaryText = PARTIAL_COD(diffPartialPaymentAmount);
        } else if (orderType === 'POD' && !paid && paymentLink) {
          primaryText = PAYMENT_SUCCESSFUL(partialPaidAmount);
          secondaryText = PARTIAL_POD(diffPartialPaymentAmount);
        }
      } else if (!orderPayableAmount && orderType === 'HBP') {
        primaryText = null;
      } else {
        // Complete payment is pending so only secondary text.
        primaryIconClass = pendingClass;
        if (orderType === 'POD') {
          primaryText = PARTIAL_POD(orderPayableAmount);
        } else {
          primaryText = PARTIAL_COD(orderPayableAmount);
        }
      }
      const primaryTextDiv = primaryText ? (
        <div className="order-confirm--payment-text">
          <Icon class={primaryIconClass} size={19} />
          <div>{primaryText}</div>
        </div>
      ) : (
        false
      );
      const secondaryTextDiv = secondaryText ? (
        <div className="order-confirm--payment-text">
          <Icon class={secondaryIconClass} size={19} />
          <div>{secondaryText}</div>
        </div>
      ) : (
        false
      );
      return { primaryTextDiv, secondaryTextDiv };
    };
    const { primaryTextDiv, secondaryTextDiv } = getPaymentText(
      this.orderNo,
      orderConfirmationDetails
    );
    return (
      <React.Fragment>
        {!orderDetails ? (
          <div className="desktop-order-confirm">
            {loading && <Loader position="absolute" />}
            <div className="desktop-order-confirm--content">
              <div className="desktop-order-confirm--content--sub-container">
                <div className="desktop-order-confirm--content--msg">
                  <div className="desktop-order-confirm--content--msg--container">
                    <div className="main-text">
                      {loading
                        ? 'Please wait, we are placing your order!'
                        : 'Your Order Is Placed!'}
                    </div>
                    <div className="payment-text">
                      {primaryTextDiv}
                      {secondaryTextDiv}
                    </div>
                    {showMembershipDetails && (
                      <MembershipPaymentMessage
                        membershipDetails={membershipDetails}
                      />
                    )}
                    {amountSavedMessage && (
                      <Messages
                        message={amountSavedMessage}
                        webClassName="desktop-save-amount--container save-amount--alignment"
                        icon={giftIcon}
                        messageStyle="desktop-save-amount--text"
                        iconStyle="desktop-save-amount--img"
                      />
                    )}
                    <div className="track-order">
                      <Link
                        to={`/my/order/${this.orderNo}`}
                        className="button button-ghost full-width large"
                        onClick={() =>
                          this.setState({ orderDetails: this.orderNo })
                        }
                      >
                        TRACK ORDER
                      </Link>
                    </div>
                    {paymentLink && (
                      <a
                        href={paymentLink}
                        className="std-margin-tb button button-primary full-width large"
                      >
                        Pay Now
                      </a>
                    )}
                  </div>
                  <div>
                    <img className="image" src={orderConfirmationImage} />
                  </div>
                </div>

                {banners && (
                  <>
                    <div className="desktop-order-confirm--content--banner-main-container">
                      {banners.map(item => {
                        return (
                          <div className="desktop-order-confirm--content--banner-sub-container">
                            {item?.hbPoints ? (
                              <Messages
                                message={item?.hbPoints}
                                webClassName="desktop-order-confirm--earnbox desktop-order-confirm--warn-color"
                                icon={earnCoin}
                                actionable={true}
                                actionText={
                                  <Icon class="icon-tada" size={21} />
                                }
                                type="toast"
                                messageStyle="desktop-order-confirm--message-style"
                                onAction={() => {}}
                              />
                            ) : (
                              <Messages
                                message={`${item?.prefix} ${item?.deliveryDate}`}
                                webClassName="desktop-order-confirm--earnbox desktop-order-confirm--blue-color"
                                icon={delivery}
                                actionable={true}
                                actionText={
                                  <Link
                                    to={`/my/order/${this.orderNo}`}
                                    className="button action-link more-white desktop-order-confirm--view-details-button"
                                  >
                                    View Details
                                  </Link>
                                }
                                type="toast"
                                messageStyle="desktop-order-confirm--message-style"
                                onAction={() => {}}
                              />
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </>
                )}
              </div>

              <div className="desktop-order-confirm--content--illustration">
                <InviteAndEarn
                  iGet={this.props.launchInfo?.referrerRewardAmount}
                  myFriendsGet={this.props.launchInfo?.refereeRewardAmount}
                  orderConfirmation={true}
                />

                <div className="desktop-order-confirm--subscribe">
                  <div className="desktop-order-confirm--subscribe--title">
                    Subscribe to know about our deals & Offers
                  </div>
                  <div className="desktop-order-confirm--subscribe--email-input">
                    <Input
                      type="text"
                      name="email"
                      className="full-width"
                      hasError={!!this.state.emailErrorMsg?.length}
                      errorMsg={this.state.emailErrorMsg}
                      suffix={
                        <Button
                          className="button action-link subscribe-cta desktop-address-card--edit-action"
                          onClick={this.subscribeToOffers}
                        >
                          SUBMIT
                        </Button>
                      }
                      onChange={({ email }) => this.setState({ email })}
                      placeholder="Enter your email id here"
                      value={this.state.email}
                      autoFocus={false}
                    />
                  </div>
                </div>
                <div>
                  <Link
                    to={'/'}
                    className="button button-primary full-width large"
                  >
                    Explore other items
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <OrderDetails orderNo={orderDetails} />
        )}
        <SimpleModal
          visible={showDonationModal}
          onCancel={() => setDonationModal(false)}
          wrapClassName="donation-modal"
          title="Thank You!"
        >
          <div>
            <div className="description">
              20% of this order is going towards Mission Oxygen, together we are
              making difference.
            </div>
            <div className="justify-content--space-between">
              <Icon src={this.kettoIcon} width={80} height={52} />
              <Icon src={this.oxygenIcon} width={115} height={133} />
            </div>
          </div>
        </SimpleModal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({
  checkoutReducer,
  initialReducer,
  modalReducer,
}) => ({
  orderConfirmationDetails: checkoutReducer.orderConfirmationDetails,
  loading: checkoutReducer.checkoutLoading,
  launchInfo: initialReducer.launchInfo,
  showDonationModal: modalReducer.confirmationModal,
});

const mapDispatchToProps = {
  getOrderConfirmation,
  subscribeNewUser,
  setAppNotification,
  setDonationModal: showConfirmationPageModal,
  resetOrderConfirmation,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderConfirmation);
